export const no = {
  COMPONENT: {
    SELECT: {
      all: 'Alle',
      search: 'Søk',
      no_results: 'Ingen resultater',
      others: '(+{{value}} andre)',
      loading: 'Laster...',
    },
  },
};
